<div class="s__stats-block">
  @for (stat of stats(); track stat.value) {
    <ds-stat-display
      [value]="stat.value"
      [label]="stat.label"
      [context]="stat.context ?? ''"
    />
  }
</div>
